<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newOpportunity'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <div class="d-flex justify-content-center mt-3"></div>
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <b-tab :title="'حمایت‌های پیشین از دوره‌'" active>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">حمایت‌های پیشین</h4>
            </template>
            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    initial.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    :href="
                      filePath + `/setad/private/1613477912994aein_forsat.pdf`
                    "
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از فرصت‌های مطالعاتی ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  id="switch_1"
                  v-model="initial.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>
            <hr />
            <h3 class="text-primary mb-4">متقاضی گرامی</h3>

            <p>
              به ابزار حمایت از طرح‌های پژوهشی سامانه تقسیم کار ملی خوش آمدید.
              خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              label="عنوان دقیق دوره"
              :class="initial.faSubject ? 'done' : 'required'"
            >
              <b-form-input trim v-model="initial.faSubject"> </b-form-input>
            </b-form-group>
            <b-form-group
              label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
              :class="initial.initialIsSupported !== null ? 'done' : 'required'"
            >
              <b-form-radio-group v-model="initial.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="initial.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="initial.initialSupportedType == 'other'"
              :class="initial.initialOtherSupport ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="initial.initialOtherSupport"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportDescription ? 'done' : 'required'"
            >
              <b-form-textarea
                trim
                rows="6"
                v-model="initial.initialSupportDescription"
              >
              </b-form-textarea>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab disabled :title="'حمایت های پیشینی از دوره'"></b-tab>
        <b-tab disabled :title="'اطلاعات اصلی دوره'"></b-tab>
        <b-tab disabled :title="'اطلاعات متقاضی'"></b-tab>
        <b-tab disabled :title="'اطلاعات اساتید'"></b-tab>
        <b-tab disabled :title="'اطلاعات تجاری‌سازی'"></b-tab>
        <b-tab disabled :title="'زمانبندی'"></b-tab>
        <b-tab disabled :title="'فایل های تکمیلی'"></b-tab>
        <b-tab disabled :title="'تعهدات'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-savedraft) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.initialObligation ||
            !initial.faSubject ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported &&
              !initial.initialSupportDescription) ||
            (initial.initialIsSupported &&
              initial.initialSupportedType == 'other' &&
              !initial.initialOtherSupport)
          "
          >آغاز فرایند</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      initial: {
        initialIsSupported: null,
      },
      tabIndex: 1,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
    };
  },

  methods: {
    start() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/opportune/new",
          {
            initialObligation: this.initial.initialObligation,
            initialIsSupported: this.initial.initialIsSupported,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.initialOtherSupport,
            initialSupportDescription: this.initial.initialSupportDescription,
            faSubject: this.initial.faSubject,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          router.push("/researcher/completeOpportunity/" + res.data);
          const title = (
            <div>
              <h5>!ثبت پیشنویس</h5>
              <span>
                پیشنویس ثبت شد. برای ثبت نهایی تکمیل کلیه اطلاعات و زدن دکمه
                ارسال الزامی است
              </span>
            </div>
          );
          this.toast(title, "info");
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    add() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.achievmentitems.push({
        name: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    remove(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.achievmentitems.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.achievmentitems.splice(order, 1);
      }
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
